export { default as useComposerBackground } from './useComposerBackground';
export {
  COMPOSER_BACKGROUND_PRESET_COLORS,
  resolveComposerBackgroundInitialState
} from './useComposerBackground';
export type {
  ComposerBackgroundMode,
  ComposerBackgroundInitialState
} from './useComposerBackground';
